import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PaymentsService } from '@payments/services/payments.service';
import { PATHS } from '@shared/constants/paths';
import { map } from 'rxjs';

export const makePaymentsGuard: CanActivateFn = () => {
  const paymentsService = inject(PaymentsService);
  const router = inject(Router);

  return paymentsService.getUserMakePaymentAccess().pipe(
    map(userPaymentAccess => {
      if (!userPaymentAccess) {
        return router.parseUrl(PATHS.PAYMENTS);
      }
      return true;
    }),
  );
};

export const paymentsGuard: CanActivateFn = () => {
  const paymentsService = inject(PaymentsService);
  const router = inject(Router);

  return paymentsService.getUserPaymentAccess().pipe(
    map(userPaymentAccess => {
      if (!userPaymentAccess) {
        return router.parseUrl(PATHS.HOME);
      }
      return true;
    }),
  );
};
